<script setup lang="ts">
defineProps({ blok: Object });
</script>

<template>
  <section class="relative py-20">
    <div
      class="absolute top-0 left-0 w-full h-[300px] bg-gradient-to-b from-chsc-raw to-transparent z-[-1]"
    />
    <UiContainer max-width="max-w-3xl">
      <header class="insight-category-header">
        <img :src="blok?.icon.filename" :alt="blok?.icon.alt" />
        <StoryblokRichText :doc="blok?.header" />
      </header>
    </UiContainer>
    <UiContainer>
      <div class="grid grid-cols-2 gap-x-20 items-center">
        <div class="flex flex-col items-center justify-center" />
      </div>
    </UiContainer>
    <UiContainer>
      <div
        class="grid grid-cols-2 gap-x-20 max-[769px]:gap-x-10 max-[641px]:grid-cols-1 max-[641px]:gap-y-10"
      >
        <div
          v-motion-slide-visible-once-bottom
          class="w-full relative border-[2px] border-chsc-indigo-500 rounded-[40px] px-6 py-8"
        >
          <h4
            class="absolute top-0 left-12 -translate-y-1/2 bg-white px-4 fs-3xl font-londrina-solid text-chsc-indigo-500 mb-6"
          >
            {{ blok?.policy_title }}
          </h4>
          <div class="grid grid-cols-2 mb-4">
            <div class="flex items-center justify-center space-x-2">
              <p class="fs-5xl font-londrina-solid text-chsc-yellow">{{ blok?.policy_large }}%</p>
              <p class="fs-2xl font-londrina-solid text-chsc-indigo-500">
                {{ blok?.companies_large }}
              </p>
            </div>
            <div class="flex items-center justify-center space-x-2">
              <p class="fs-5xl font-londrina-solid text-chsc-yellow">
                {{ blok?.policy_retailers }}%
              </p>
              <p class="fs-2xl font-londrina-solid text-chsc-indigo-500">
                {{ blok?.companies_retailers }}
              </p>
            </div>
          </div>
          <div
            class="[&>p]:font-londrina-solid [&>p]:leading-[20px] [&>p]:fs-2xl [&>p]:text-chsc-indigo-500 [&>p>strong]:fs-4xl [&>p>strong]:text-chsc-yellow"
          >
            <StoryblokRichText :doc="blok?.policy_description" />
          </div>
        </div>
        <div
          v-motion-slide-visible-once-bottom
          class="w-full relative border-[2px] border-chsc-indigo-500 rounded-[40px] px-6 py-8"
        >
          <h4
            class="absolute top-0 left-12 -translate-y-1/2 bg-white px-4 fs-3xl font-londrina-solid text-chsc-indigo-500 mb-6"
          >
            {{ blok?.certifications_title }}
          </h4>
          <div class="grid grid-cols-2 mb-4">
            <div class="flex items-center justify-center space-x-2">
              <p class="fs-5xl font-londrina-solid text-chsc-yellow">
                {{ blok?.certifications_large }}%
              </p>
              <p class="fs-2xl font-londrina-solid text-chsc-indigo-500">
                {{ blok?.companies_large }}
              </p>
            </div>
            <div class="flex items-center justify-center space-x-2">
              <p class="fs-5xl font-londrina-solid text-chsc-yellow">
                {{ blok?.certifications_retailers }}%
              </p>
              <p class="fs-2xl font-londrina-solid text-chsc-indigo-500">
                {{ blok?.companies_retailers }}
              </p>
            </div>
          </div>
          <div
            class="[&>p]:font-londrina-solid [&>p]:leading-[20px] [&>p]:fs-2xl [&>p]:text-chsc-indigo-500 [&>p>strong]:fs-4xl [&>p>strong]:text-chsc-yellow"
          >
            <StoryblokRichText :doc="blok?.certifications_description" />
          </div>
        </div>
      </div>
    </UiContainer>
    <UiContainer max-width="max-w-2xl" class="mt-20">
      <div class="insighr-category-description text-center mb-12">
        <StoryblokRichText :doc="blok?.description" />
      </div>
      <div
        class="text-center [&>p]:font-eb-garamond [&>p]:fs-2xl [&>h4]:font-londrina-solid [&>h4]:fs-5xl [&>h4]:text-chsc-indigo-500 [&>h4>strong]:text-chsc-yellow [&>p]:mb-6 [&>h4]:mb-6"
      >
        <StoryblokRichText :doc="blok?.claim" />
      </div>
    </UiContainer>

    <img
      v-motion-slide-visible-once-bottom
      :src="blok?.image.filename"
      :alt="blok?.image.alt"
      class="absolute bottom-6 left-6 max-[769px]:hidden"
    />
  </section>
</template>
